import API from "../../../../services/api";

// ==========================================
// Get Customer Orders
// ==========================================

export const getCustomerOrders = async () => {

    const res = await API.get("/orders/customer");

    return res.data;

};

// ==========================================
// Get Single Order
// ==========================================

export const getOrderById = async (orderId) => {

    const res = await API.get(`/orders/${orderId}`);

    return res.data;

};

// ==========================================
// Cancel Order
// ==========================================

export const cancelOrder = async (orderId) => {

    const res = await API.patch(
        `/orders/${orderId}/cancel`
    );

    return res.data;

};